import BlockTitle from './BlockTitle.tsx';
import {RichBlockComponentProps} from './blockComponents.tsx';
import {getBestTranslatedValue} from '../../../lib/localeHelper.ts';
import {ImageBlockData} from '../../../types/api.ts';
import {getBestTranslatedAsset} from '../../../services/api/AssetApi.ts';

export default function ImageBlock({
    isPreview,
    userLocales,
    data: {title, url, trackingUrl, asset, translations},
    locale,
}: RichBlockComponentProps<ImageBlockData>) {
    if (!asset) {
        return null;
    }

    const translatedAsset = getBestTranslatedAsset(asset, userLocales);

    const assetUrl = translatedAsset.url;
    if (!assetUrl) {
        return null;
    }

    const resolvedTitle = getBestTranslatedValue(
        translations ?? {},
        'title',
        title,
        locale,
        userLocales,
    );

    const resolvedUrl = getBestTranslatedValue(
        translations ?? {},
        'url',
        url,
        locale,
        userLocales,
    );
    const resolvedTrackingUrl = getBestTranslatedValue(
        translations ?? {},
        'trackingUrl',
        trackingUrl,
        locale,
        userLocales,
    );

    const target = !isPreview
        ? resolvedTrackingUrl || resolvedUrl
        : resolvedUrl;

    const img = (
        <img
            style={{
                width: '100%',
                height: 'auto',
                objectFit: 'cover',
                borderRadius: '8px',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            }}
            src={assetUrl}
            alt={resolvedTitle || translatedAsset.name || 'Image'}
        />
    );

    return (
        <>
            <BlockTitle title={resolvedTitle} />
            {target ? (
                <a href={target} target={'_blank'} rel={'noopener noreferrer'}>
                    {img}
                </a>
            ) : (
                img
            )}
        </>
    );
}
